import type { FaireProductEntity } from "../../entity_types/product";

export const p_9euq5n5qfu: FaireProductEntity = {
  token: "p_9euq5n5qfu",
  type: "product",
  name: "Ojai Lavender - 3.5 oz Reed Diffuser",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/0938513c5d0c8fcd3839095907e9b369e9e98a491aacbbf98d25fc368b239363.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d724033d48a8272ab64b1a55de8a89a4a2153044e18d9da3177e0baef11f4bc2.jpeg",
    "https://cdn.faire.com/fastly/4d5cef6fcce08763f6753dd8c0bdf1521166237459cb18973df556dfd797b0a3.jpeg",
    "https://cdn.faire.com/fastly/be83086637055d198072996a2ce0bdc87fff96d78ae5cd50c79a3d9c1dce9448.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
    "https://cdn.faire.com/fastly/3ec3b40ddf2d4f1d916cabf565664c386c5376775b70151546c6ca3cbe6a81fc.jpeg",
    "https://cdn.faire.com/fastly/3b84c7448c1fd4ba405db55ed07ec4e0f06691eb41a63bb53f5e1efcda2c2e1c.jpeg",
  ],
  priceDollars: 14.5,
  description:
    'Sun-drenched fields, orange groves and lavender farms, jagged mountains washed in a rosy, sunset glow. Pixie tangerine, lavender, mint.\n\nLow-maintenance, flame-free, and always-on scent for entry ways, bathrooms, dorm rooms, and bedrooms.\n\nEach diffuser contains a 3.5 fl oz blend of naturally-derived and man-made fragrance oils in a 4 oz amber apothecary-inspired bottle. Includes a bundle of 9" long naturally-harvested rattan reeds to absorb and slowly release the fragrance. \n\nLasts approximately 3-4 months, flip reeds weekly.',
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:58.331Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
